export const FETCH_PUBLIC_EVENTS_REQUEST = 'FETCH_PUBLIC_EVENTS_REQUEST'
export const FETCH_PUBLIC_EVENTS_SUCCESS = 'FETCH_PUBLIC_EVENTS_SUCCESS'
export const FETCH_PUBLIC_EVENTS_FAILURE = 'FETCH_PUBLIC_EVENTS_FAILURE'

export const FETCH_SINGLE_PUBLIC_EVENT_REQUEST = 'FETCH_SINGLE_PUBLIC_EVENT_REQUEST'
export const FETCH_SINGLE_PUBLIC_EVENT_SUCCESS = 'FETCH_SINGLE_PUBLIC_EVENT_SUCCESS'
export const FETCH_SINGLE_PUBLIC_EVENT_FAILURE = 'FETCH_SINGLE_PUBLIC_EVENT_FAILURE'
